import { styled } from '@mui/system';
import Image from 'next/image';
import MuiCheckIcon from '@mui/icons-material/Check';

const CheckIconStyled = styled(MuiCheckIcon)`
  color: #00a650;
  height: 19.2px;
  width: 19.2px;
`;

const CheckCircleDiv = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1.2px solid #00a650;
  border-radius: 100px;
  width: 32px;
  height: 32px;
`;

export const CheckIcon = () => {
  return (
    <CheckCircleDiv>
      <CheckIconStyled />
    </CheckCircleDiv>
  );
};

interface WarningIconProps {
  width?: number;
  height?: number;
}

const WarningIconContainer = styled('div')<WarningIconProps>(
  ({ width, height }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width,
    height: height,
  }),
);

export const WarningIcon = ({ width = 40, height = 32 }: WarningIconProps) => {
  return (
    <WarningIconContainer width={width} height={height}>
      <Image
        src="/assets/images/warningIcon.png"
        alt="Warning icon"
        width={width}
        height={height}
      />
    </WarningIconContainer>
  );
};
